/* SYNCED from shotbook-landing/src/lib/cx.ts — не править руками, запускать npm run sync:ds */
/**
 * Склейка классов. Принимает undefined и false, чтобы условные классы
 * писались без тернарников с пустой строкой.
 *
 * Значения из CSS-модулей типизированы как string | undefined
 * (в tsconfig включён noUncheckedIndexedAccess), поэтому нужен именно такой вход.
 */
export function cx(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
